<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Ampun Hasil"
        :crumbs="crumbs"
    >
        <z-page :title="`Senarai Pengecualian (${total})`" :append-button="true">
            <w-flex column :gap="3">
                <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input v-model="searchParams.tarikh_dari" type="date"
                                >Tarikh Dari</w-input
                            >
                            <w-input v-model="searchParams.tarikh_hingga" type="date"
                                >Tarikh Hingga</w-input
                            >
                            <z-lookup
                                :url="
                                    this.apiBaseUrl +
                                    '/daerah'"
                                :sort="false"
                                :cache="false"
                                label="Daerah"
                                v-model="searchParams.daerah"
                            />
                            <!-- <w-select
                                :items="[
                                    { value: 'null', label: 'Semua' },
                                    { value: '1', label: 'Aktif' },
                                    { value: '0', label: 'Tidak Aktif' },
                                ]"
                                label="Status"
                                v-model="searchParams.status"
                            ></w-select> -->
                            <w-button
                            bg-color="primary"
                            class="align-self-end"
                            :loading="loading"
                            type="submit"
                            >
                                <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </w-flex>
                    </w-flex>
                </w-form>
                <w-flex class="justify-space-between">
                    <w-button class="align-self-end"
                    bg-color="success"
                    :loading="loading"  @click="printPdf($page.props.auth.user.jabatan_id)">
                    <w-icon class=" mr2 "> fal fa-print</w-icon>
                    &nbsp;Cetak&nbsp;
                    </w-button>
                </w-flex>
                <Table
                    :headers="pengecualian.headers"
                    :items="loading ? [] : pengecualian.items"
                    :loading="loading"
                >
                    <template #item-cell.bil="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>

                    <template
                        #item-cell.created_at="{ item, label, header, index }"
                    >
                    <div v-if="item.created_at!=null">
                        {{ moment(item.created_at).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Mula
                    </div>
                    </template>

                    <template
                        #item-cell.flag="{ item, label, header, index }"
                    >
                    <div v-if="item.flag_kod!=null" style="text-transform:uppercase;">
                        {{ item.flag_kod}} - {{item.flag_keterangan }}
                    </div>
                    <div v-else>
                        Tiada Flag Dikenalpasti
                    </div>
                    </template>

                    <template
                        #item-cell.cukai="{ item, label, header, index }"
                    >
                    <div v-if="item.cukai!=null" align="right">
                        {{ item.cukai}}
                    </div>
                    <div v-else>
                        Tiada Cukai
                    </div>
                    </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage"
                    :currentPage="pagination.currentPage"
                    :perPage="pagination.perPage"
                    @onClick="onPaginationChange($event)"
                />
            </w-flex>

        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";
import Table from "../../Component/Table";
import TablePagination from "../../Component/TablePagination";

export default {
    extends: ZResource,
    components: { Table, TablePagination },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            total: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                lastPage: 1,
            },
            statusOptions: [
                { value: "null", label: "Semua" },
                { value: "1", label: "Aktif" },
                { value: "0", label: "Tidak Aktif" },
            ],

            pengecualian: {
                headers: [
                    { label: "Bil", key: "bil" },
                    { label: "Tarikh", key: "created_at" },
                    { label: "No. Hakmilik", key: "no_hm" },
                    { label: "Syarat Tanah", key: "syarat_tanah" },
                    { label: "Flag", key: "flag" },
                    { label: "Cukai Semasa", key: "cukai"},
                ],
                items: [],
            },
            searchParams: {
                tarikh_dari: null,
                tarikh_hingga: null,
                daerah: null,
                status: null,
            },
            searching: false,
            hasSearched: false,

            districts: [],
            hm:[]
        };
    },
    methods: {
        printPdf($x){
                  for (var key in this.searchParams) {
                    if (String(this.searchParams[key]) === "null" || String(this.searchParams[key]) === "undefined") {
                      delete this.searchParams[key];
                    }
                  }
                var queryString = Object.keys(this.searchParams)
                .map((key) => key + "=" + this.searchParams[key])
                .join("&");
                const w= $x;
                window.open( `${this.apiBaseUrl}/cukai/laporanPengecualian/printPdf?${queryString}&jabatan=${w}`,"_blank");
        },
        moment(date) {
            return moment(date);
        },
        onPaginationChange(e) {
            this.pagination.currentPage = e.value.currentPage;
            this.pagination.perPage = e.value.perPage;
            this.fetchData2();
        },
        filter() {
            this.searchParams.status =
                this.searchParams.status === "null"
                    ? null
                    : this.searchParams.status;
            this.fetchData2();
        },
        async fetchData2() {
            this.searchParams.limit = this.pagination.perPage;
            this.searchParams.offset =
                (this.pagination.currentPage - 1) * this.pagination.perPage;
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/laporanPengecualian`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                console.log(e.data);
                const { limit, offset, total, data } = e.data;
                this.total = total;
                this.pagination.lastPage = Math.ceil(total / limit);
                this.pengecualian.items = data;
            });

            this.loading = false;
        },
        async fetchDaerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.id,
                    };
                });

            });
        },
    },
    computed: {
        getLastPage() {
            return this.total > 0
                ? Math.ceil(this.total / this.pagination.perPage)
                : 1;
        },
        getSearch(){

        },
    },
    mounted() {
        this.fetchData2();
        this.fetchDaerah();
    },
};
</script>
